import clsx from 'clsx'
import React from 'react'
import { Header2 } from '../../MaterialUi/Typo'
import { useStyle } from './Style'
import { TitleContainerProps } from './Type'

export const LayoutTitleContainer: React.FC<TitleContainerProps> = ({
  className,
  line,
  secondary,
  customTitleComponent,
  children,
  ...props
}): React.ReactElement => {
  const classes = useStyle()

  const renderTitle = () => (
    // TS ignore because of : https://github.com/mui-org/material-ui/issues/22452
    // eslint-disable-next-line
    // @ts-ignore
    <Header2
      {...props}
      component="h3"
      className={clsx(
        className,
        classes.h3,
        line && classes.h3WithLine,
        secondary && classes.h3Secondary
      )}
    >
      {children}
    </Header2>
  )
  return (
    <div data-testid="titleWithLine">
      {!customTitleComponent ? renderTitle() : children}
      {line && <div className={clsx(classes.line, 'layoutTitleContainer__line')} />}
    </div>
  )
}
